import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type LegalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-heading font-bold text-cream-100 mb-6" data-id="element-46">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-cream-200/90 leading-relaxed" data-id="element-47">
      <p data-id="element-48">
        <strong className="text-cream-100" data-id="element-49">Última actualización:</strong> Enero
        2025
      </p>
      <p data-id="element-50">
        Tu privacidad es importante para nosotros. Esta política describe cómo
        recopilamos, usamos y protegemos tu información personal.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-51">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-52">
        Recopilamos únicamente la información necesaria para procesar tu compra:
        nombre, dirección de correo electrónico y datos de pago. No almacenamos
        datos de tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-53">
        2. Uso de la Información
      </h4>
      <p data-id="element-54">Utilizamos tu información exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-55">
        <li data-id="element-56">Procesar y entregar tu compra digital.</li>
        <li data-id="element-57">Enviarte el producto adquirido por correo electrónico.</li>
        <li data-id="element-58">Comunicarnos contigo sobre tu pedido si es necesario.</li>
      </ul>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-59">
        3. Protección de Datos
      </h4>
      <p data-id="element-60">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-61">
        4. Terceros
      </h4>
      <p data-id="element-62">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de pago necesarios para
        completar tu transacción.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-63">
        5. Cookies
      </h4>
      <p data-id="element-64">
        Podemos utilizar cookies para mejorar tu experiencia de navegación.
        Puedes desactivarlas en la configuración de tu navegador.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-65">
        6. Tus Derechos
      </h4>
      <p data-id="element-66">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-heading font-bold text-cream-100 mb-6" data-id="element-67">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-cream-200/90 leading-relaxed" data-id="element-68">
      <p data-id="element-69">
        <strong className="text-cream-100" data-id="element-70">Última actualización:</strong> Enero
        2025
      </p>
      <p data-id="element-71">
        Al adquirir el producto "Ritual de Paz Nocturna", aceptas los siguientes
        términos y condiciones.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-72">
        1. Producto Digital
      </h4>
      <p data-id="element-73">
        El producto consiste en una guía digital en formato PDF. Una vez
        completada la compra, recibirás acceso inmediato al material
        descargable.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-74">
        2. Uso Personal
      </h4>
      <p data-id="element-75">
        El contenido adquirido es para uso personal y exclusivo del comprador.
        Queda prohibida la reproducción, distribución o reventa del material sin
        autorización expresa.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-76">
        3. Naturaleza Informativa
      </h4>
      <p data-id="element-77">
        Este producto tiene fines informativos y educativos. No sustituye el
        consejo médico profesional. Si padeces trastornos del sueño graves,
        consulta a un profesional de la salud.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-78">
        4. Resultados
      </h4>
      <p data-id="element-79">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos, ya que dependen de factores individuales y de la
        aplicación consistente del método.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-80">
        5. Política de Reembolso
      </h4>
      <p data-id="element-81">
        Debido a la naturaleza digital del producto, no se aceptan devoluciones
        una vez descargado el material. Si tienes problemas con la descarga, nos
        comprometemos a resolverlos.
      </p>

      <h4 className="text-lg font-heading font-semibold text-cream-100 pt-2" data-id="element-82">
        6. Modificaciones
      </h4>
      <p data-id="element-83">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación en esta
        página.
      </p>
    </div>
  </>;
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalType>(null);
  return <>
      <footer className="relative z-10 py-10 px-6 border-t border-cream-200/10 bg-night-900" data-id="element-84">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-cream-200/50" data-id="element-85">
          <span className="font-body" data-id="element-86">
            © {new Date().getFullYear()} Ritual de Paz Nocturna
          </span>
          <span className="hidden sm:inline text-cream-200/20" data-id="element-87">|</span>
          <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-400 transition-colors duration-200 font-body underline underline-offset-2 decoration-cream-200/20 hover:decoration-gold-400" data-id="element-88">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-cream-200/20" data-id="element-89">|</span>
          <button onClick={() => setOpenModal('terms')} className="hover:text-gold-400 transition-colors duration-200 font-body underline underline-offset-2 decoration-cream-200/20 hover:decoration-gold-400" data-id="element-90">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Legal Modal */}
      {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} data-id="element-91">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-night-950/80 backdrop-blur-sm" onClick={() => setOpenModal(null)} data-id="element-92" />

          {/* Modal Content */}
          <div className="relative w-full max-w-2xl max-h-[80vh] bg-night-800 border border-cream-200/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-93">
            {/* Close Button */}
            <button onClick={() => setOpenModal(null)} className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-night-900/80 hover:bg-night-700 text-cream-200/60 hover:text-cream-100 transition-colors duration-200" aria-label="Cerrar" data-id="element-94">
              <XIcon className="w-5 h-5" data-id="element-95" />
            </button>

            {/* Scrollable Content */}
            <div className="p-8 md:p-10 overflow-y-auto max-h-[80vh] font-body" data-id="element-96">
              {openModal === 'privacy' ? privacyContent : termsContent}
            </div>
          </div>
        </div>}
    </>;
}